<h1 matDialogTitle  style="padding: 0px;margin: 0px;font-weight: bolder;">Confirm</h1>
<h2 mat-dialog-content style="padding-top: 10px;padding-bottom: 10px;">{{confirmMessage}}</h2>
<div mat-dialog-actions align="end" >  
  <button (click)="dialogRef.close(true)" class="mat-accent mr-16" mat-raised-button>Confirm</button>  
  <button (click)="dialogRef.close(false)" class="mat-warn" mat-raised-button>Cancel</button>
</div>
